import {useState, useEffect} from 'react'
import './Service.css'
import {Read} from '../Shared/Api'

const Services = ({lang, account, service}) => {

    const [loaded, Load] = useState(false)
    const [items , Items] = useState([])
  
    useEffect(()=>{        
  
      if(service>0) {
        Read(`/service/${service}`, Items, Load)
      }
  },[service])
  
    return (
        <div className='Services' id='services' >

        {items.map((item) => (
            <Service name={item.Name} id={`Service-${item.Id}`} key={`Service-${item.Id}`}
            icon={item.Icon} 
            info={item.Info}
            plan={item.Plan}
            start={item.Start}
            to={item.Link}
          />
        ))}

</div>
    )

}

const Service = ({name, icon, info, plan, start, to, style}) => {

    //alert(info)

    return (
        <div className='Service' style={style}>
            <div className="center">
                <a target="_blank" rel="noopener noreferrer" href={to}>
                    <img src={icon.startsWith('https') ? icon : to+icon} alt={name+": "+info} />
                </a>
            </div>
            <br/>
            <div className="ServiceName">
                <h1 style={{fontWeight: 'bold'}}>{name}</h1>
                <h4 className="ServiceInfo">{info}</h4>
                <br/>
                <h3 className="ServiceInfo">{plan}</h3>
                {style && start?.length>0 ?
                <div style={{width:'100%', position:'relative'}}>
                <a href={to} target="_blank" rel="noreferrer" >
                    <button className='Button'
                        style={to.includes('telegram') ? {backgroundColor:'rgb(40,170,240)'} : null }
                    >
                    {start}
                    </button>
                </a>
                </div>
                : null }
            </div>
        </div>
    )
}

export {Service, Services}

